import { render } from "./App.vue?vue&type=template&id=ca678b7e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=ca678b7e&lang=css"
script.render = render

export default script